import { render, staticRenderFns } from "./SidePanelColorCalcs.vue?vue&type=template&id=78bb7655&scoped=true&"
import script from "./SidePanelColorCalcs.vue?vue&type=script&lang=js&"
export * from "./SidePanelColorCalcs.vue?vue&type=script&lang=js&"
import style0 from "./SidePanelColorCalcs.vue?vue&type=style&index=0&id=78bb7655&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bb7655",
  null
  
)

export default component.exports